// extracted by mini-css-extract-plugin
export default {"container_cards":"_cards_container_cards__nfJuZ","msg":"_cards_msg__81az-","loading":"_cards_loading__DZ4PW"};